import React from 'react';
import { Alert, Box } from '@mui/material';

const EnvironmentWarningMessages = ({ warningMessages, isInline = false }) => {
  // Don't render anything if there are no warning messages
  if (!warningMessages || !Array.isArray(warningMessages) || warningMessages.length === 0) {
    return null;
  }

  // Function to determine if a color is light or dark
  const isLightColor = (hexColor) => {
    if (!hexColor) return true; // Default to light if no color provided
    
    // Remove # if present
    const hex = hexColor.replace('#', '');
    
    // Convert to RGB
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    
    // Calculate luminance
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    
    return luminance > 0.5;
  };

  // Function to get appropriate text color based on background
  const getTextColor = (backgroundColor) => {
    const isLight = isLightColor(backgroundColor);
    return isLight ? '#2d3748' : '#f7fafc'; // Dark text on light bg, light text on dark bg
  };

  // Function to get appropriate icon color based on background
  const getIconColor = (backgroundColor) => {
    const isLight = isLightColor(backgroundColor);
    return isLight ? '#d69e2e' : '#fbb040'; // Darker warning icon on light bg, lighter on dark bg
  };

  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      gap: isInline ? 0.5 : 1, 
      maxWidth: isInline ? '100%' : '600px',
      margin: isInline ? '0' : '0 auto'
    }}>
      {warningMessages.map((warning, index) => {
        const backgroundColor = warning.sandbox_warning_color || '#fff3cd';
        const textColor = getTextColor(backgroundColor);
        const iconColor = getIconColor(backgroundColor);
        
        return (
          <Alert
            key={`${warning.environment_id}-${index}`}
            severity="warning"
            sx={{
              backgroundColor: backgroundColor,
              color: textColor,
              border: `1px solid ${backgroundColor}`,
              borderRadius: '4px',
              fontSize: isInline ? '12px' : '14px',
              minHeight: isInline ? 'auto' : 'inherit',
              padding: isInline ? '4px 8px' : '6px 16px',
              '& .MuiAlert-icon': {
                color: iconColor,
                fontSize: isInline ? '16px' : '22px',
                marginRight: isInline ? '4px' : '12px'
              },
              '& .MuiAlert-message': {
                padding: 0,
                display: 'flex',
                alignItems: 'center'
              }
            }}
          >
            <Box sx={{ 
              display: 'flex', 
              alignItems: 'center',
              flexWrap: isInline ? 'nowrap' : 'wrap'
            }}>
              <strong style={{ marginRight: '4px' }}>{warning.environment_name}:</strong>
              <span>{warning.sandbox_warning_message}</span>
            </Box>
          </Alert>
        );
      })}
    </Box>
  );
};

export default EnvironmentWarningMessages;
